
import { Vue, Component } from 'vue-property-decorator'
import {
    DataDTO, statisticByGoodsName, statisticByGoodsNameTop10,
    statisticByGoodsBrand, statisticByGoodsBrandTop10, statisticByGoodsCategory, statisticByGoodsCategoryTop10,
    statisticByArea, statisticByDept, statisticByAreaTop10, statisticByDeptTop10,
} from '@/api/dataReport'
import { exportFileWithData } from '@/utils/h5ToApp'
import DataSelect from '@/views/dataReport/template/dataSelect.vue'
import dayjs from 'dayjs'
import { Chart } from '@antv/g2'
import { moneyFormat, handlePercentage } from '@/utils/util'
import LineListCard from '@/views/dataReport/template/lineListCard.vue'
import { Getter } from 'vuex-class'
import { GetOrganizationInfoAll } from '@/api/customerManage'
import TypeProp from '@/views/dataReport/template/TypeProp.vue'
import AreaPopup from '@/views/dataReport/template/AddrPopup.vue'
import { colors } from '../chartColors'

@Component({
    name: 'AreaOrderReport',
    components: {DataSelect, LineListCard, TypeProp, AreaPopup}
})
export default class AreaOrderReport extends Vue {
    @Getter companyId!: string
    readonly format = 'YYYY-MM-DD'
    moneyFormat = moneyFormat
    handlePercentage = handlePercentage
    colors = colors
    queryParams = {
        startDate: dayjs().format(this.format),
        endDate: dayjs().format(this.format),
        checkType: '1',//查看方式,'1'按订单查看 '2' 按商品查看
        deptId: '', //部门id
        deptLevelIds: '',//部门级别编号
        orderType: 'desc', // 排序方式 asc:升序, desc:降序
        statisticalSection: 'area', // 统计方式
        statisticalSectionId: '', // 统计区间编号
        areaName: '全部区域', //地区名称
        areaId: '', //读取id
        sortType: '1', //排序字段  1：订货数量2：订货金额3：退货数量4：退货金额5：订货单数量6：退货单数量
        type: '1', // 商品排行方式 1. 按商品统计  2. 按商品分类统计  3. 按商品品牌统计
        hierarchyId: '',// 商品分类层级编号
        pageIndex: 1,
        pageSize: 10
    }
    deptName = '部门'
    sortName = '排列方式'

    loading = false
    finished = false
    refreshing = false

    statisticOptions = [
        {text: '按区域统计', value: 'area'},
        {text: '按部门统计', value: 'dept'}
    ]
    showStatistic = false

    // 部门选择数据
    depList = []
    showDept = false

    // 订单排行方式
    sortTypeOption = [
        {text: '订货单数量排行', value: '1'},
        {text: '退货单数量排行', value: '2'},
        {text: '订货金额排行', value: '3'},
        {text: '退货金额排行', value: '4'}
    ]
    showSort = false

    chartData: DataDTO[] = [] //饼图数据
    chart: Chart | null = null
    list: DataDTO[] = [] //列表数据

    get listType () {
        let type1 = [
            {
                text: '订货单',
                key: 'rorderCount',
            },
            {
                text: '订货金额',
                key: 'orderMoneyCount',
                type: 'money'
            },
            {
                text: '退货单',
                key: 'returnOrderCount',
            },
            {
                text: '退货金额',
                key: 'returnOrderMoneySum',
                type: 'money'
            },
            {
                text: '获批退款金额',
                key: 'returnOrderMoney',
                type: 'money'
            }
        ]
        let type2 = [
            {
                text: '订货单',
                key: 'orderCount',
            },
            {
                text: '订单收货数量',
                key: 'receiveCount',
            },
            {
                text: '订单收货金额',
                key: 'receiveMoneyCount',
                type: 'money'
            },
            {
                text: '退货单数量',
                key: 'returnOrderCount',
            },
            {
                text: '退单退货数量',
                key: 'returnCount',
            },
            {
                text: '退单退货金额',
                key: 'returnMoneyCount',
                type: 'money'
            }
        ]
        return this.queryParams.checkType === '1' ? type1 : type2
    }

    get topLeft () {
        let key = 'areaName'
        if (this.queryParams.checkType === '1' && this.queryParams.statisticalSection === 'area') { // 按订单查看/地区
            key = 'areaName'
        } else if (this.queryParams.checkType === '1' && this.queryParams.statisticalSection === 'dept') { // 按订单查看/部门
            key = 'deptName'
        }

        if (this.queryParams.checkType === '2' && this.queryParams.type === '1') { // 按商品查看/商品名称
            key = 'goodsName'
        } else if (this.queryParams.checkType === '2' && this.queryParams.type === '2') { // 按商品查看/品牌
            key = 'brandName'
        } else if (this.queryParams.checkType === '2' && this.queryParams.type === '3') { // 按商品查看/分类
            key = 'categoryName'
        }

        return key
    }

    get params () {
        let params: any = {}
        params = {
            startDate: this.queryParams.startDate,
            endDate: this.queryParams.endDate,
            sortType: this.queryParams.sortType,
            orderType: this.queryParams.orderType
        }
        if (this.queryParams.statisticalSection === 'area') { //按区域统计
            Object.assign(params, {type: '1'})
            Object.assign(params, {areaId: this.queryParams.areaId})
        } else {
            Object.assign(params, {type: '2'})
            Object.assign(params, {deptId: this.queryParams.deptId})
            Object.assign(params, {deptLevelIds: this.queryParams.deptLevelIds})
        }
        return params
    }

    get statisticText () {
        let text = '地区'
        switch (this.queryParams.statisticalSection + '') {
            case 'area':
                text = '地区'
                break
            case 'dept':
                text = '部门'
                break
            default:
                text = '地区'
                break
        }
        return text
    }

    get sortTypeText () {
        let text = '订货单数量'
        switch (this.queryParams.sortType + '') {
            case '1':
                text = '订货单数量'
                break
            case '2':
                text = '退货单数量'
                break
            case '3':
                text = '订货金额'
                break
            case '4':
                text = '退货金额'
                break
        }
        return text
    }

    get sortTypeValue () {
        let text = 'orderCount'
        switch (this.queryParams.sortType + '') {
            case '1':
                text = 'rorderCount'
                break
            case '2':
                text = 'returnOrderCount'
                break
            case '3':
                text = 'orderMoneyCount'
                break
            case '4':
                text = 'returnMoneySum'
                break
        }
        return text
    }

    created () {
        this.load()
        this.getDepList()
    }

    orderTypeList = [
        {
            text: '按订单统计',
            value: 1
        },
        {
            text: '按商品统计',
            value: 2
        },
    ] // 数据请求方式列表

    mounted () {
        this.initChart()
        // 监听更多筛选
        this.$eventBus.$on('areaMoreFilter', (res: any) => {
            this.queryParams.deptId = res.deptId
            this.queryParams.checkType = res.orderType
            this.queryParams.statisticalSection = res.statisticType
            this.queryParams.areaName = res.areaName
            this.queryParams.areaId = res.areaId
            this.queryParams.sortType = res.sortType
            this.queryParams.type = res.type
            this.queryParams.deptLevelIds = res.levelIds
            // 刷新列表数据
            this.load()
        })
    }

    /**
     * 获取客户分组列表
     */
    getDepList () {
        GetOrganizationInfoAll({companyId: this.companyId}).then((res: any) => {
            this.depList = res.data
            this.depList.forEach(item => {
                // if (item.isEnabled === '0' || item.orgType === '1') {
                if (item.isEnabled === '0') {
                    item.disabled = true
                }
                item.text = item.orgName
                item.value = item.orgId
            })
            this.queryParams.deptId = this.depList[0].orderId
        })
    }

    load () {
        this.queryParams.pageIndex = 1
        this.finished = false
        this.list = []
        this.getList()
    }

    /**
     * 初始化饼图
     */
    initChart () {
        const data: any = [
            {name: '', compareValue: 0,random:''}
        ]

        const chart = new Chart({
            container: 'order-chart-container',
            autoFit: true,
            height: 280
        })

        chart.legend(false)

        chart.coordinate('theta', {
            radius: 0.6,
            innerRadius: 0.55
        })

        chart.data(data)

        chart.tooltip({
            showTitle: false,
            showMarkers: false
        })
        chart
            .interval()
            .position('compareValue')
            .color('random', this.colors)
            .label('percentage', (val) => {
                let isLabel = val > 0.2
                if (isLabel) {
                    return {
                        content: (data) => {
                            return `${data.name.length > 5 ? data.name.slice(0, 5) + ' ...' : data.name}:\n ${handlePercentage(data.percentage)}`
                        },
                        style: {
                            fill: '#313131',
                        },
                        layout: {type: 'pie-spider'},
                    }
                }
            })
            .tooltip('name*compareValue', (name, compareValue) => {
                return {
                    name: name,
                    value: compareValue,
                }
            })
            .adjust('stack')


        chart.interaction('element-active')

        chart.render()
        this.chart = chart
    }

    /**
     *  区域类型选择完毕
     */
    handleStatisticChange (obj: any) {

        this.showStatistic = false
        this.queryParams.statisticalSection = obj.value
        this.load()
    }

    /**
     *  部门类型选择完毕
     */
    handleDeptChange (obj: any) {
        this.showDept = false
        this.queryParams.deptId = obj.value
        this.deptName = obj.orgName
        this.load()
    }

    /**
     *  排行方式选择完毕
     */
    handleSortChange (obj: any) {
        this.showSort = false
        this.queryParams.sortType = obj.value
        this.sortName = obj.text
        this.load()
    }

    /**
     * 区域选择改变
     * @param addressId
     * @param addressName
     * @param index
     */
    handleAddressChange ({addressId, addressName}) {

        this.queryParams.areaId = addressId
        this.queryParams.areaName = addressName
        this.load()
    }

    /**
     * @description: 地区选择弹框打开
     */
    handleShowAreaOrDept () {
        if (this.queryParams.statisticalSection === 'area') {
            (this.$refs.areaPopup as AreaPopup).showPop()
        } else {
            this.showDept = true
        }
    }

    /**
     * 获取列表和饼图数据
     */
    getList () {
        this.getListByOrder()
    }

    /**
     * 按订单查看/按商品查看tab改变
     */
    handleTabChange () {
        console.log(this.queryParams.checkType)
    }

    /**
     *按订单查看的数据请求
     */
    getListByOrder () {
        if (this.queryParams.statisticalSection === 'area') { //按区域统计
            statisticByArea({...this.params}).then(res => {
                this.list = res.data
                this.finished = true
            })
            statisticByAreaTop10({
                ...this.params
            }).then(res => {
                this.chartData = res.data
              this.chartData.map((item,index) => {
                item.random = item.name + index
              })
                if (this.chartData.length > 0) {
                    this.$nextTick(() => {
                        this.chart!.data(this.chartData)
                        this.chart!.render()
                    })
                }
            })
        } else if (this.queryParams.statisticalSection === 'dept') { // 按部门统计
            statisticByDept(this.params).then(res => {
                this.list = res.data
                this.finished = true
            })
            statisticByDeptTop10({
                ...this.params
            }).then(res => {
                this.chartData = res.data
                this.chartData.map((item,index) => {
                  item.random = item.name + index
                })
                if (this.chartData.length > 0) {
                    this.$nextTick(() => {
                        this.chart!.data(this.chartData)
                        this.chart!.render()
                    })
                }
            })
        }
    }

    /**
     * 头部总时间段改变
     * @param value
     */
    handleDataChange (value: Array<string>) {
        this.queryParams.startDate = value[0]
        this.queryParams.endDate = value[1]
        this.queryParams.startDate = value[0]
        this.queryParams.endDate = value[1]
        this.load()
    }

    /**
     * 导出数据
     */
    handleExport () {
        exportFileWithData({
            method: 'post',
            portUrl: '/cykjreport/RegionalStatistics/exportAreaOrder',
            params: JSON.stringify(Object.assign({companyId: this.companyId}, {...this.params}))
        })
    }
}
